export const getRepeatsCount = (duration?: number | null, playDuration?: number | null) =>
  (duration && playDuration && Math.round(playDuration / duration)) || 0;

export const sortItemsByOrder = <T extends { order?: number | null }>(items: T[]) =>
  [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const assignOrderByIndex = <T>(items: T[]) => items.map((item, index) => ({ ...item, order: index + 1 }));

export const formatMillisecondsToTime = (ms?: number | null): string => {
  if (!ms) return '';
  if (ms < 0 || Number.isNaN(ms)) return '00:00:00';
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const formatPart = (num: number): string => num.toString().padStart(2, '0');
  return `${formatPart(hours)}:${formatPart(minutes)}:${formatPart(seconds)}`;
};
